/*
 * @Author: mayanxia 
 * @Date: 2022-04-27 16:29:15 
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-07-12 16:30:12
 */


<!--批量导入界面-->
<template>
    <a-modal
        :title="title"
        :width="800"
        :visible="visible"
        :confirmLoading="confirmLoading"
        :okButtonProps="{ props: {disabled: disableSubmit} }"
        :maskClosable="maskClosable"
        @ok="handleOk"
        @cancel="handleCancel"
        :cancelText="$t('关闭')">
        
        <a-spin :spinning="confirmLoading">
            <a-form-model ref="formModal" :model="model" :rules="rules" :colon="false" layout="vertical">
                <div>
                    <a-row :gutter="24">
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item has-feedback :label="$t('设备ID')" prop="deviceId">
                                <a-input :placeholder="$t('请输入设备ID')" v-model.trim="model.deviceId" :disabled="!!model.id||disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('设备名称')" prop="deviceName">
                                <a-input :placeholder="$t('请输入设备名称')" v-model="model.deviceName" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('安装位置')" prop="deviceLocation">
                                <a-input :placeholder="$t('请输入设备安装位置')" v-model="model.deviceLocation" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('设备类型')" prop="deviceType">
                                <j-dict-select-tag v-model="model.deviceType" :placeholder="$t('请选择设备类型')" dictCode="wq_device_type" :disabled="disableSubmit"></j-dict-select-tag>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('平台类型')" prop="iotType">
                                <j-dict-select-tag v-model="model.iotType" :placeholder="$t('请选择平台类型')" dictCode="platform_type" :disabled="disableSubmit"></j-dict-select-tag>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="12" :lg="12" :md="12" :sm="24">
                            <a-form-model-item :label="$t('SIM卡号')" prop="simCode">
                                <a-input :placeholder="$t('请输入SIM卡号')" v-model="model.simCode" :disabled="disableSubmit"></a-input>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-model-item :label="$t('安装经度')" prop="longitude">
                                <a-input-number v-model="model.longitude" :placeholder="$t('请输入安装经度')" style="width:100%" :min="0" :precision="6" :disabled="disableSubmit"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="6">
                            <a-form-model-item :label="$t('安装纬度')" prop="latitude">
                                <a-input-number v-model="model.latitude" :placeholder="$t('请输入水表安装纬度')" style="width:100%" :min="0" :precision="6" :disabled="disableSubmit"/>
                            </a-form-model-item>
                        </a-col>
                        <a-col :xl="24" :lg="24" :md="24" :sm="24">
                            <a-form-model-item :label="$t('描述')" prop="remark">
                                <a-textarea v-model="model.remark" rows="3" :placeholder="$t('请输入备注')" style="width:100%" :disabled="disableSubmit" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                </div>
            </a-form-model>
        </a-spin>
    </a-modal>
</template>

<script>
    import { httpAction,getAction,uploadAction } from '@/api/manage'
    import { ACCESS_TOKEN } from "@/store/mutation-types"
    import {isUndefined} from'@/utils/validate'
    import { validateDuplicateValue } from '@/utils/util'
    import Vue from 'vue'
    import { mapGetters } from 'vuex'
    export default {
        name: 'MeterDeviceBaseModal',
        props: {
            //表单禁用
            disabled: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        data () {
            return {
                visible: false,
                disableSubmit:false,
                tokenHeader: {'X-Access-Token': Vue.ls.get(ACCESS_TOKEN)},
                maskClosable:false,
                model: {
                    deviceId: '',
                    deviceName: '',
                    deviceLocation: '',
                    deviceType: '',
                    iotType: null,
                    simCode: '',
                    longitude: null,
                    latitude: null

                },
                confirmLoading: false,
                url: {
                    add: "/jeecg-charge/wq/meterDeviceBase/add",
                    edit: "/jeecg-charge/wq/meterDeviceBase/edit",
                    queryDeviceInfoByUserId: "/jeecg-charge/wq/meterDeviceBase/list"
                },
                fileNewList: [],
                fileOldList: [],
                fileFotaList: []
            }
        },
        computed: {
            title() {
                return this.$t('操作')
            },
            rules() {
                return {
                    deviceId:[
                        { required: true, message: this.$t('请输入设备ID')},
                        // {validator: this.validateDeviceId},
                        // {
                        //     validator: (rule, value, callback) => {
                        //         validateDuplicateValue('meter_device_base', 'device_id', value, this.model.id, callback)
                        //     }
                        // }
                    ],
                    deviceName:[{ required: true, message: this.$t('请输入设备名称')}],
                    deviceLocation:[{ required: true, message: this.$t('请输入设备安装位置')}],
                    deviceType:[{ required: true, message: this.$t('请选择设备类型')}],
                }
            }
        },
        created () {

        },
        methods: {
            ...mapGetters(["userInfo"]),
            add() {
                this.edit({});
            },
            edit (record) {
                this.visible = true;
                this.model = Object.assign(this.model,record)
            },
            handleOk(){
                const that = this;
                // 触发表单验证
                this.$refs.formModal.validate(valid => {
                    if(valid) {
                        that.confirmLoading = true;
                        let httpurl = '';
                        let method = '';
                        if(!this.model.id){
                            httpurl+=this.url.add;
                            method = 'post';
                        }else{
                            httpurl+=this.url.edit;
                            method = 'put';
                        }
                        let formData = Object.assign(this.model, {});
                        httpAction(httpurl,formData,method).then((res)=>{
                        if(res.success){
                            that.$message.success(res.message);
                            setTimeout(() => {
                                that.$emit('ok');
                            },400)
                        }else{
                            that.$message.warning(res.message);
                        }
                        }).finally(() => {
                            that.confirmLoading = false;
                            this.close();
                        }) 
                    }
                })
            },
            close () {
                this.$emit('close');
                this.model = this.$options.data.call(this).model
                this.$refs.formModal.resetFields()
                this.disableSubmit = false;
                this.visible = false;
            },

            handleCancel () {
                this.close();
            },
            validateDeviceId(rule, value, callback){
                if(isUndefined(value)) {
                    callback()
                    return
                }
                let params = {deviceId: this.model.deviceId}
                getAction(this.url.queryDeviceInfoByUserId,params).then((res) => {
                    if (res.success&&res.result.records.length>0) {
                        if(this.model.id&&res.result.records[0].id === this.model.id) {
                            callback()
                        }else{
                            callback(this.$t('该设备ID已存在，请重新输入!'))
                        }
                    } else {
                        callback()
                    }
                })
            }
        }
    }
</script>
<style scoped>
    .ant-form-item >>> .ant-select{
    width: 100%;
    }
    .span {
    margin: 8px;
    }
    .detail-list >>> .content{
    line-height: normal;
    }
</style>